var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVdo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22,
    fill: "#E8F2FF",
    stroke: "#4E97EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2487 18.5423C27.2487 17.6691 26.5386 16.959 25.6654 16.959H16.1654C15.2922 16.959 14.582 17.6691 14.582 18.5423V26.459C14.582 27.3322 15.2922 28.0423 16.1654 28.0423H25.6654C26.5386 28.0423 27.2487 27.3322 27.2487 26.459V23.8204L30.4154 26.459V18.5423L27.2487 21.1809V18.5423Z",
    fill: "#4E97EC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVdo);
export default __webpack_public_path__ + "static/media/vdo.cd3e27fac81d7451232eabf4361eff29.svg";
export { ForwardRef as ReactComponent };